// KnowledgeExplorerHeader.jsx
import React from 'react';

const KnowledgeExplorerHeader = ({ title, onSave }) => {
  return (
    <div className="bg-white p-4 flex justify-between items-center rounded-lg shadow mb-4">
      <h2 className="text-xl font-medium">{title || "Knowledge Explorer"}</h2>
      <button
        onClick={onSave}
        className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Save
      </button>
    </div>
  );
};

export default KnowledgeExplorerHeader;